import Card from './Card.vue'
export default Card



// WEBPACK FOOTER //
// ./components/Card/index.js